//Link of where I found the logical screen heights (window.outerHeight) of all iPhone models: https://www.ios-resolution.com/
//I checked the values of window.outerHeight in runtime when debbuging Safari on the iOS Simulator and they are correct.
//The values of the inner height of Safari for all iPhone devices, I got them debugging Safari using the iOS Simulator.

//iPhone 5, iPhone 5C, iPhone 5S, iPhone SE 1st gen, iPod touch 5th gen, iPod touch 6th gen, iPod touch 7th gen
export const IPHONE_HEIGHT_568 = 568;
export const SAFARI_INNER_HEIGHT_449 = 449;

//iPhone 6, iPhone 6s, iPhone 7, iPhone 8, iPhone SE 2nd gen (< iOS 16), iPhone SE 3rd gen (< iOS 16)
export const IPHONE_HEIGHT_667 = 667;
export const SAFARI_INNER_HEIGHT_548 = 548;

//iPhone SE 3rd gen (iOS 16+)
export const SAFARI_INNER_HEIGHT_549 = 549;

//iPhone SE 2nd gen (iOS 16+)
export const SAFARI_INNER_HEIGHT_1435 = 1435;

//iPhone 6 Plus, iPhone 6s Plus, iPhone 7 Plus, iPhone 8 Plus
export const IPHONE_HEIGHT_736 = 736;
export const SAFARI_INNER_HEIGHT_617 = 617;

//iPhone X, iPhone XS, iPhone 11 Pro (iOS <26), iPhone 12 mini, iPhone 13 mini
export const IPHONE_HEIGHT_812 = 812;
export const SAFARI_INNER_HEIGHT_635 = 635;

//iPhone 11 Pro (iOS 26+)
export const SAFARI_INNER_HEIGHT_670 = 670;

//iPhone 12, iPhone 12 Pro, iPhone 13, iPhone 13 Pro, iPhone 14, iPhone 16e
export const IPHONE_HEIGHT_844 = 844;

//iPhone 16e
export const SAFARI_INNER_HEIGHT_663 = 663;

//iPhone 12 Mini (iOS 26+), iPhone 13 Mini (iOS 26+)
export const SAFARI_INNER_HEIGHT_664 = 664;

//iPhone 14 Pro, iPhone 15, iPhone 15 Pro, iPhone 16
export const IPHONE_HEIGHT_852 = 852;
export const SAFARI_INNER_HEIGHT_659 = 659;

//iPhone 16 Pro
export const IPHONE_HEIGHT_874 = 874;
export const SAFARI_INNER_HEIGHT_678 = 678;

//iPhone 14 Pro (iOS 26+), iPhone 15 (iOS 26+), iPhone 16 (iOS 26+)
export const SAFARI_INNER_HEIGHT_695 = 695;

//iPhone 12 Pro (iOS 26+), iPhone 13 (iOS 26+), iPhone 13 Pro (iOS 26+), iPhone 14 (iOS 26+), iPhone 16e (iOS 26+)
export const SAFARI_INNER_HEIGHT_699 = 699;

//iPhone 16 Pro (iOS 26+), iPhone 17, iPhone 17 Pro
export const SAFARI_INNER_HEIGHT_714 = 714;

//iPhone XR, iPhone XS Max, iPhone 11 (iOS <26), iPhone 11 Pro Max
export const IPHONE_HEIGHT_896 = 896;
export const SAFARI_INNER_HEIGHT_719 = 719;

//iPhone 11 (iOS 26+)
export const SAFARI_INNER_HEIGHT_750 = 750;

//IPhone 11 Pro Max (iOS 26+)
export const SAFARI_INNER_HEIGHT_754 = 754;

//iPhone 14 Pro Max (iOS 26+), iPhone 15 Plus (iOS 26+)
export const SAFARI_INNER_HEIGHT_775 = 775;

//iPhone 12 Pro Max (iOS 26+), iPhone 13 Pro Max (iOS 26+)
export const SAFARI_INNER_HEIGHT_781 = 781;

//iPhone Air
export const IPHONE_HEIGHT_912 = 912;

//iPhone 12 Pro Max, iPhone 13 Pro Max, iPhone 14 Plus
export const IPHONE_HEIGHT_926 = 926;

//iPhone 12 Pro Max, iPhone 13 Pro Max, iPhone 14 Plus, iPhone Air
export const SAFARI_INNER_HEIGHT_746 = 746;

//iPhone 14 Pro Max, iPhone 15 Plus, iPhone 15 Pro Max, iPhone 16 Plus
export const IPHONE_HEIGHT_932 = 932;
export const SAFARI_INNER_HEIGHT_739 = 739;

//iPhone 16 Pro Max
export const IPHONE_HEIGHT_956 = 956;
export const SAFARI_INNER_HEIGHT_760 = 760;

//iPhone 16 Pro Max (iOS 26+), iPhone 17 Pro Max
export const SAFARI_INNER_HEIGHT_796 = 796;

//Tolerance (px) for real-device vs iOS Simulator inner-height drift.
//The inner heights above were measured on the iOS Simulator and can be off by a
//pixel or two on real hardware (e.g. iPhone 17 reports 713 where the Simulator
//reports 714). This tolerance is comfortably below the Safari-vs-SFSafariViewController
//gap (a navigation bar, tens of px), so it absorbs measurement drift without
//letting real in-app browsers through.
export const SAFARI_INNER_HEIGHT_TOLERANCE = 5;

//These device types are documented here.
//https://docs.uaparser.dev/info/device/type.html
export const INVALID_DEVICE_TYPES = ['console', 'embedded', 'smarttv', 'wearable', 'xr'];


// WEBPACK FOOTER //
// ./src/constants/device.js